import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ArticleService {
  constructor (private http: HttpClient) {}

  /*getAll() {
    return this.http.get(`https://api-prod.kharaaj.com/api/v1/articles`);
  }*/

  getAll () {
    return this.http.get(`https://api-prod.kharaaj.com/api/v1/articles`)
  }

  getAllCategories () {
    return this.http.get(
      `https://api-prod.kharaaj.com/api/v1/articles/categories`
    )
  }

  getFilteredArticles(filters: any): Observable<any> {
    let params = new HttpParams();
  
    // Add search param only if it exists and has length > 0
    if (filters.search && filters.search.trim().length > 0) {
      params = params.set('search', filters.search.trim());
    }
  
    // Add category param only if it exists and has length > 0
    if (filters.category && filters.category.trim().length > 0) {
      params = params.set('category', filters.category.trim());
    }
  
    // Add page param with default value 0 if not provided
    const page = filters.page || 0;
    params = params.set('page', page.toString());
  
    // Add limit param with default value 10 if not provided
    const limit = filters.limit || 10;
    params = params.set('limit', limit.toString());
  
    return this.http.get(
      'https://api-prod.kharaaj.com/api/v1/articles/filtredArticles',
      { params }
    );
  }
  /*getLatest() {
    return this.http.get(`https://api-prod.kharaaj.com/api/v1/articles/latest`);
  }*/
  getLatest () {
    return this.http.get(`https://api-prod.kharaaj.com/api/v1/articles/latest`)
  }

  getOne (articleId: string) {
    return this.http.get(
      `https://api-prod.kharaaj.com/api/v1/articles/${articleId}`
    )
  }
  postReview (articleId: string, review: any) {
    return this.http.post(
      `https://api-prod.kharaaj.com/api/v1/articles/post-review/${articleId}`,
      review
    )
  }
  getArticleWithReviews (articleId: string): Observable<any> {
    return this.http.get(
      `https://api-prod.kharaaj.com/api/v1/articles/reviews/${articleId}`
    )
  }

  getArticleStats (articleId: string): Observable<any> {
    return this.http.get(
      `https://api-prod.kharaaj.com/api/v1/articles/average-evaluation/${articleId}`
    )
  }
}
